{
  "loading": "Laster inn ...",
  "placeholder": "Velg et alternativ..."
}
